import React from 'react';
import './css/Partners.css';

import aluwoodProduct from '../img/aluwood pic/шил метал.jpg';
import ajMongonAltaiLogo from '../img/partners/0-02-08-accbe292179d7569b3e8831da566053b3b40fadb0802f6ad306607d5421a3060_2b89ab4ecc1f8a8c.jpg';


const Partners: React.FC = () => {
    return (
        <div className="combined-page">
            <div className="combined-container">
                {/* Header Section */}
                <div className="combined-header">
                    <div className="title-section">
                        <h1 className="main-title">ХАМТРАГЧИД</h1>
                        <p className="subtitle">CROWN RESIDENCE төслийн итгэлт түншүүд</p>
                    </div>
                </div>

                {/* Пасад Section */}
                <section className="content-section-partners">
                    <h2 className="section-title">Пасад</h2>
                    <div className="section-content">
                        <p>
                            Crown Residence төсөл нь орон сууцны төслийн пасадыг хийсэн
                        </p>

                        <div className="partner-hero">
                            <div className="partner-logo-container">
                                <img src={ajMongonAltaiLogo} alt="Аж Мөнгөн Алтай ХХК лого" className="partner-logo-img" />
                            </div>
                            <h2 className="partner-title">Аж Мөнгөн Алтай ХХК</h2>
                            <p className="partner-tagline">Орон сууцны төслийн пасад - Төсөл хөгжүүлэлт</p>
                        </div>

                        <div className="investment-projects">
                            <h3>Гүйцэтгэсэн төслүүд</h3>
                            <div className="projects-grid">
                                <div className="project-category">
                                    <h4>Орон сууцны төслүүд</h4>
                                    <ul className="project-list">
                                        <li>• Шүншиг Вилла 1</li>
                                        <li>• Шүншиг Вилла 2</li>
                                        <li>• Шүншиг Вилла 3</li>
                                        <li>• Гоёл Кашмер</li>
                                        <li>• Гоёл Аппартмент</li>
                                        <li>• Evel Apartment</li>
                                        <li>• Өмнөговь аймгийн Оюу Реседенс</li>
                                    </ul>
                                </div>
                                <div className="project-category">
                                    <h4>Пасадын давуу тал</h4>
                                    <ul className="project-list">
                                        <li>• Олон жилийн туршлага</li>
                                        <li>• Тогтвортой пасадын үүрэг</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Windows & Doors Section */}
                <section className="content-section-partners">
                    <h2 className="section-title">ЦОНХ</h2>
                    <div className="section-content">
                        <p>
                            <strong>ШИЛ МЕТАЛ ХХК</strong> нь барилгын материал үйлдвэрлэлээр олон жил
                            дагнан ажиллаж хуримтлуулсан туршлага, хэрэглэгчийн ажиглалт, судалгааны
                            явц дээрээ үндэслэн Монгол орны цаг агаарын нөхцөлд тохирсон цонх хаалгын
                            шийдлийг боловсруулж, дотоодын барилгын салбар нэвтрүүлж байна.
                        </p>

                        <div className="main-product">
                            <div className="product-hero">
                                <div className="product-image-container">
                                    <img src={aluwoodProduct} alt="ALUWOOD-78 Цонх Хаалга" className="product-image-img" />
                                </div>
                                <h2 className="product-title">ALUWOOD-78 МАРКИЙН ЦОНХ ХААЛГА</h2>
                                <p className="product-tagline">Мод, металл хосолмол материал - Дулаан тусгаарлах шинэлэг шийдэл</p>
                            </div>

                            <div className="product-details">
                                <div className="detail-card">
                                    <h4>Үндсэн шинж чанар</h4>
                                    <p>
                                        <strong>ALUWOOD-78</strong> маркийн рам нь 68мм-н зузаан, дулаан тусгаарлах
                                        PVC жийрэгтэй    бөгөөд металл рамны дотор талд 10мм-н зузаан текстолит
                                        модон давхарлагатай.
                                    </p>
                                </div>

                                <div className="detail-card">
                                    <h4>Технологийн давуу тал</h4>
                                    <ul className="feature-list-partners">
                                        <li>• Дулаан тусгаарлалт Rш = 82% хувь хүртэл</li>
                                        <li>• Цонх хаалга дулаан алдах, рамаа дагаж хэвдэх, цантах,
                                            жиндүү хүйтэн байх зэрэг хүндрэлүүдийг бүрэн шийдсэн</li>
                                        <li>• Модны өнгөлгөө доторлогоо нь өнгө үзэмжтэй, тансаг орчныг бүрдүүлэг</li>
                                    </ul>
                                </div>

                                <div className="detail-card">
                                    <h4>Баталгаажуулалт</h4>
                                    <p>
                                        Барилга Архитектур Корпорацийн сорилтын албаар баталгаажуулсан
                                        сертификаттай бүтээгдэхүүнийг зах зээлд нийлүүлж байна.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Technology Solutions Section */}
                <section className="content-section-partners">
                    <h2 className="section-title">Технологийн шийдлүүд</h2>
                    <div className="section-content">
                        <div className="technology-grid">
                            <div className="technology-category">
                                <h4>Шилний багц</h4>
                                <ul className="technology-list">
                                    <li>• 5мм-н гурван давхар, хатаах ганжуулсан шилээр үйлдвэрлэгдсэн</li>
                                    <li>• 0,07 м³-с дээш эзэлхүүнтэй шилэн багцыг инертийн хийгээр хийлж гаргах технологийг ашиглаж, шилэн багц агаарын хэмээс шалтгаалж агших, пөмбийх хөдөлгөөнгүй </li>
                                </ul>
                            </div>

                            <div className="technology-category">
                                <h4>Материалын шийдэл</h4>
                                <ul className="technology-list">
                                    <li>• Металл + мод хосолмол материал (Италийн "Ronchety Lear" фирмийн бэлдэц)</li>
                                    <li>• Текстолит материалаар бүтээгдсэн нь сүүлийн 3 жил ямар нэг доголдолгүй ашиглагдаж байна</li>
                                    <li>• Чийгний нөлөөнд ордоггүй материал</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Benefits Section */}
                <section className="content-section-partners">
                    <h2 className="section-title">Бүтээгдэхүүний давуу талууд</h2>
                    <div className="section-content">
                        <div className="benefits-grid">
                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>Өндөр дулаан тусгаарлалт</h4>
                                    <p>Rш = 82% хүртэлх дулаан тусгаарлалтын үзүүлэлттэй</p>
                                </div>
                            </div>

                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>Урт наслалт</h4>
                                    <p>Текстолит материал нь 3+ жил ямар нэг доголдолгүй ажиллаж байна</p>
                                </div>
                            </div>

                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>Цаг агаарын нөхцөлд тохирсон</h4>
                                    <p>Монгол орны хатуу цаг агаарын нөхцөлд зориулан боловсруулсан</p>
                                </div>
                            </div>

                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>Чанартай материал</h4>
                                    <p>Металл мод хосолмол материал, Италийн фирмийн бэлдэц</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content-section-partners">
                    <h2 className="section-title">Хамтын ажиллагааны давуу тал</h2>
                    <div className="section-content">
                        <div className="benefits-grid">
                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>10+ жилийн туршлага</h4>
                                    <p>2014 оноос хойш барилгын салбарт тасралтгүй ажиллаж буй туршлагатай баг</p>
                                </div>
                            </div>

                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>Олон улсын стандарт</h4>
                                    <p>Дэлхийн шилдэг компаниудтай хамтран ажиллах, олон улсын стандартыг мөрдөх</p>
                                </div>
                            </div>

                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>Цогц үйлчилгээ</h4>
                                    <p>Гадаад тохижилтоос эхлээд тавилгын үйлдвэрлэл хүртэлх бүх үйлчилгээг нэг дор</p>
                                </div>
                            </div>

                            <div className="benefit-item">
                                <div className="benefit-content">
                                    <h4>Баталгаатай чанар</h4>
                                    <p>Монголын томоохон төслүүдэд амжилттай хэрэгжүүлсэн баталгаатай чанар</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="content-section-partners">
                    <h2 className="section-title">Холбоо барих</h2>
                    <div className="section-content">
                        <div className="contact-grid">
                            <div className="contact-category">
                                <h4>ШИЛ МЕТАЛ ХХК</h4>
                                <div className="contact-info">
                                    <div className="contact-item-partners">
                                        <span className="contact-icon">📍</span>
                                        <div className="contact-details">
                                            <h5>Хаяг</h5>
                                            <p>
                                                Улаанбаатар, Сонгинохайрхан дүүрэг, бгд-ийн 20-р хороо үйлдвэрийн баруун бүс москвагийн 76б</p>
                                        </div>
                                    </div>
                                    <div className="contact-item-partners">
                                        <span className="contact-icon">📞</span>
                                        <div className="contact-details">
                                            <h5>Утас</h5>
                                            <p>9916-5658</p>
                                        </div>
                                    </div>
                                    <div className="contact-item-partners">
                                        <span className="contact-icon">🌐</span>
                                        <div className="contact-details">
                                            <h5>Сошиал медиа</h5>
                                            <a href="https://www.facebook.com/profile.php?id=100064336681476" className="Partners-link" target="_blank" rel="noopener noreferrer">
                                                facebook.com/profile.php?id=100064336681476
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    );
};

export default Partners;